import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Paper,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Colors } from "helpers/Consts";
import { useTheme } from "@mui/system";
import * as CompositionPricing from "../../helpers/Composition";
import {
  IEditItemShoppingBagParams,
  IShoppingBagData,
  IShoppingBagItem,
  IUpdateItemShoppingBag,
} from "types/ShoppingBag";
import { useFormik } from "formik";
import { Fragment, useEffect, useState } from "react";
import { Edit } from "@mui/icons-material";
import { useMutationItemUpdateShoppingBag } from "services/api/mutations/useMutationUpdateItemShoppingBag";
import { ICompositionGroup, ICompositionGroupList, ICompositionItemObject } from "types/Product";
import EditItemBagDialogSkeleton from "./EditItemBagDialogSkeleton";
import _ from "lodash";
import SeletorDeQuantidadeDeSabores from "../FoodDialog/components/SeletorDeQuantidadeDeSabores";
import SeletorAlternativa from "../FoodDialog/components/SeletorAlternativa";
import SeletorCheckboxes from "../FoodDialog/components/SeletorCheckboxes";
import SeletorQuantidadeDoItemOuSabor from "../FoodDialog/components/SeletorQuantidadeDoItemOuSabor";
import logger from "../../components/Logger";

type Props = {
  originalProduct: IShoppingBagItem;
  shoppingBag: IShoppingBagData;
}

function EditItemBagDialog({ originalProduct, shoppingBag }: Props) {
  // Usamos o cloneDeep para evitar que alterações aqui sejam refletidas automaticamente no originalProduct.
  // Queremos que o usuário possa cancelar as edições
  const product = _.cloneDeep(originalProduct);

  // ATENÇÂO: estamos assumindo que vai ter no máximo uma categoria que controla sabores!!
  //logger.log('originalProduct', originalProduct);
  const idCategoriaSabor = originalProduct.compositionGroups?.find(c => c.compositionGroupInfo?.flavour_control)?.compositionGroupInfo?.id;
  //logger.log('idCategoriaSabor', idCategoriaSabor);
  const quantosSaboresOriginal = originalProduct.compositionGroups?.find(c => c.compositionGroupInfo?.flavour_control)
    ?.compositionGroupItems.reduce((acc, obj) => acc + (obj.quantity > 0 ?1:0), 0) ?? 0;
//logger.log('quantosSaboresOriginal', quantosSaboresOriginal);


  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState<boolean>(false);
  const { mutate: setShoppingBag } = useMutationItemUpdateShoppingBag();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_order_id: shoppingBag.id,
      product_id: product?.id,
      quantity: shoppingBag?.items.filter(
        (item: IShoppingBagItem) => item.id === product.id
      )[0].quantity,
      unit_price: product?.productInfo.new_price,
      total_price:
        product?.productInfo.new_price *
        shoppingBag?.items.filter(
          (item: IShoppingBagItem) => item.id === product.id
        )[0].quantity,
      flavour_control: false,
      observations: shoppingBag.items.filter(
        (item: IShoppingBagItem) => item.id === product.id
      )[0].observations,
      total_value: shoppingBag.items.filter(
        (item: IShoppingBagItem) => item.id === product.id
      )[0].total_price,
      compositionGroups: shoppingBag.items.filter(
        (item: IShoppingBagItem) => item.id === product.id
      )[0].compositionGroups as ICompositionGroup[],
    } as IEditItemShoppingBagParams,
    onSubmit: async (values) => {

      if(handleDisabledButtonComposition()){
        alert('Por favor, preencha todos os campos obrigatórios.');
        return;
      }

      const updateParams: IUpdateItemShoppingBag = {
        body: {
          flavour_control: values.flavour_control,
          quantity: values.quantity,
          total_price: Number(values.total_value),
          unit_price: Number(values.total_value) / values.quantity,
          observations: values.observations,
          compositionGroups: values.compositionGroups
        },
        params: {
          itemId: product.id,
          orderId: shoppingBag.id,
        },
      };

      formik.setSubmitting(false);
      setShoppingBag(updateParams);
      handleDialogState();
    },
  });
  // Handle Quantidade Produto Total
  const handleQuantity = (action: string) => {
    // console.log(formik.values.total_value);
    let unitPrice = formik.values.total_value! / formik.values.quantity;

    // console.log(unitPrice);
    if (action === "add") {
      formik.setFieldValue("quantity", formik.values.quantity + 1, true);
      formik.setFieldValue(
        "total_value",
        (unitPrice) *
          (formik.values.quantity + 1),
        true
      );
    } else {
      formik.setFieldValue("quantity", formik.values.quantity - 1, true);
      formik.setFieldValue(
        "total_value",
        (unitPrice) *
          (formik.values.quantity - 1),
        true
      );
    }
  };
  // Handle Quantidade por Categoria (Composições)
  function getSelectedItemsCountFor(category: ICompositionGroupList) : number {

    const array = formik.values.compositionGroups?.find(
      (item) => item.composition_group_id === category.id,
    );

    if(!array?.compositionGroupItems || (array?.compositionGroupItems?.length ?? 0) < 1) {
      return 0;
    }

    const arrayAux = array.compositionGroupItems.filter(
      (item) => item.users_orders_items_composition_groups_id === array?.id,
    );

    if(!arrayAux || arrayAux?.length < 1) {
      return 0;
    }

    return arrayAux?.reduce((accumulator, obj) => {
      return accumulator + obj.quantity;
    }, 0);
  }

  // Handle Item por Composição ( Composições )
  const handleCompositionItem = (
    item: ICompositionItemObject,
    action: string,
    category: ICompositionGroupList
  ) => {

    const compositionClone = [...(formik.values.compositionGroups ?? [])];

    const array = formik.values.compositionGroups?.find(
      (item) => item.composition_group_id === category.id
    );
    const itemFound = array?.compositionGroupItems.find(
      (itemF) => itemF.id === item.id
    );
    if (action === "add") {
      if (getSelectedItemsCountFor(category)! < category.max) {
        if (
          itemFound &&
          itemFound.users_orders_items_composition_groups_id === array?.id
        ) {
          itemFound.quantity += 1;
        }
      }
    } else {
      if (
        itemFound &&
        itemFound.users_orders_items_composition_groups_id === array?.id
      ) {
        itemFound.quantity -= 1;
      }
    }
    const valorTotal = (formik.values.unit_price + CompositionPricing.getPriceCompositionOnEditing(formik.values.compositionGroups)) *
      formik.values.quantity;

    formik.setFieldValue(
      "total_value",
      valorTotal,
      true
    );
    formik.setFieldValue(
      "compositionGroups",
      compositionClone,
      true
    );
  };

  // Handle Disable Button se for Composição e não tiver Completo
  function handleDisabledButtonComposition(): boolean {

    //logger.log('product.compositionGroups', product.compositionGroups);

    if (product.compositionGroups.length) {
      if (
        product.compositionGroups.some(
          (category) => !isQuantidadeItensEscolhidosSuficiente(category.compositionGroupInfo)
        )
      ) {
        return true;
      }
    }
    return false;
  }

  // Handle Select RadioButtons
  const handleSelect = (
    item: ICompositionItemObject,
    category: ICompositionGroupList
  ) => {
    //console.log('select', item, category);
    let zerou = false;
    const array = formik.values.compositionGroups?.find(
      (item) => item.composition_group_id === category.id
    );
    const itemFound = array?.compositionGroupItems.find(
      (itemF) => itemF.quantity === 1
    );
    if (
      itemFound &&
      itemFound.users_orders_items_composition_groups_id === array?.id
    ) {
      //console.log('itemfound', itemFound);
      zerou = true;
      itemFound.quantity = 0;
    }

    let newItem = array?.compositionGroupItems.find(
      (itemF) => itemF.id === item.id
    );

    if(newItem && newItem.id === itemFound?.id && zerou) {
      newItem = undefined;
    }

    if (newItem) {

      newItem.quantity = 1;
    }
    formik.setFieldValue(
      "total_value",
      (formik.values.unit_price + CompositionPricing.getPriceCompositionOnEditing(formik.values.compositionGroups)) *
        formik.values.quantity,
      true
    );
    formik.setFieldValue(
      "compositionGroups",
      formik.values.compositionGroups,
      true
    );
  };


  /**
   * Mapa da escolha que o usuário fez de quantos sabores ele quer numa category que controla sabores (flavour_control)
   *  OBS: em teoria, era para poder funcionar com produtos permitindo mais de uma categoria que escolhe sabores.
   *       Na prática, os produtos só vão ter no máxima uma categoria com sabor (pelo menos assim que está definido
   *       o cadastro de produtos lá no Restaurante Desktop. O problema na verdade é que o Restaurante desktop só permite
   *       uma categoria com sabor, para produtos lançados pelo Restaurante Desktop. Talvez poderia lançar lá como kit ou combo...
   *       mas de qualquer forma, o ponto é que na prática por enquanto não vai ter produto com mais de uma categoria que
   *       controla sabores.
   *
   * key: id da categoria
   * value: quantidade escolhida para sabores
   */
  const [qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario, setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario]
    = useState<Map<number, number>>(new Map());

  function selecionaQuantidadeDeSabor(idCategoria: number, qtdEscolhida: number){
    logger.log('entrou em selecionaQuantidadeDeSabor')
    setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario((prevState) => {
      logger.log('dentro do setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario em selecionaQuantidadeDeSabor')
      logger.log('oldstate = ', prevState)
      const newState = new Map(prevState);
      newState.set(idCategoria, qtdEscolhida);
      logger.log(newState)
      return newState;
    })
  }

  // resetar o mapa de escolhas de sabores quando o dialog fecha
  useEffect(() => {
    if(open){
      logger.log('vai resetar!')
      if(idCategoriaSabor !== undefined && quantosSaboresOriginal !== undefined){
        selecionaQuantidadeDeSabor(idCategoriaSabor, quantosSaboresOriginal);
      }

    }

    if(!open){
      //logger.log('vai resetar!')
      setQtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario(new Map());
    }
  }, [open])

  const isQuantidadeItensEscolhidosSuficiente = (category: ICompositionGroupList) => {
    logger.log('category.id: ', category.id);

    if(category.id == 146){
      logger.log('category.flavour_control: ', category.flavour_control)
    }

    if(category.flavour_control){
      logger.log('qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario', qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id))


      return qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id) === getSelectedItemsCountFor(category)
    }

    if(!category.mandatory) return true;
    // se não controla sabores, a qtd escolhida está entre min e max?
    return getSelectedItemsCountFor(category) <= category.max
      && getSelectedItemsCountFor(category) >= category.min
  }

  const seletorDeItem = (item: ICompositionItemObject, category: ICompositionGroupList) =>{

    const array = formik.values.compositionGroups?.find(
      (item) => item.composition_group_id === category.id,
    );
    const itemDoFormik = array?.compositionGroupItems.find(
      (itemF) => itemF.id === item.id
    );

    if(category.max === 1){
      return (<SeletorAlternativa
        handleSelect={() => handleSelect(item, category)}
        value={item.name}
        checked={itemDoFormik?.quantity === 1}
      />)
    }

    if(category.flavour_control){
      const totalSaboresEscolhidos = getSelectedItemsCountFor(category);
      const qtdMaxEscolhidaPeloUsuario = qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.id);
      return(
        <SeletorCheckboxes
          handleSelect={() =>{
            // alterna entre qtd 1 e 0, apenas
            if(!itemDoFormik) return;
            itemDoFormik.quantity === 1
              ? handleCompositionItem(item, "remove", category)
              : handleCompositionItem(item, "add", category)}
          }
          value={item.name}
          checked={itemDoFormik?.quantity === 1}
          disabled={qtdMaxEscolhidaPeloUsuario === undefined // usuário ainda não escolheu a quantidade de sabores
            || (itemDoFormik?.quantity === 0 && totalSaboresEscolhidos === qtdMaxEscolhidaPeloUsuario)}
        />
      )
    }

    return(
      <>
        <SeletorQuantidadeDoItemOuSabor
          selectedQuantity={item.quantity}
          handleAdd={() => handleCompositionItem(item, "add", category)}
          handleSubtract={() => handleCompositionItem(item, "remove", category)}
          addDisabled={
            getSelectedItemsCountFor(category) === category.max
            /*|| item.quantity === 1*//*|| item.quantity === 1*/
          }
          subtractDisabled={item.quantity === 0}
        />
      </>)
  }

  const handleDialogState = () => {
    setOpen(!open);
  };
  return (
    <>
      <IconButton
        size="small"
        onClick={() => {
          handleDialogState();
        }}
      >
        <Edit
          sx={{
            width: "20px",
            height: "20px",
          }}
        />
      </IconButton>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={() => {
          handleDialogState();
          formik.values.total_value =
            (product.unit_price + CompositionPricing.getPriceCompositionOnEditing(formik.values.compositionGroups)) * product.quantity;
          formik.values.quantity = product.quantity;
          formik.values.observations = product.observations;
        }}
        maxWidth={"lg"}
      >
        <DialogTitle color={Colors.orangePrimary}>
          <Box display="flex" alignItems="center">
            <Box>
              <IconButton
                color="primary"
                onClick={() => {
                  handleDialogState();
                  formik.values.total_value =
                    (product.unit_price + CompositionPricing.getPriceCompositionOnEditing(formik.values.compositionGroups)) *
                    product.quantity;
                  formik.values.quantity = product.quantity;
                  formik.values.observations = product.observations;
                }}
              >
                <ArrowBackIosIcon fill={Colors.orangePrimary} />
              </IconButton>
            </Box>
            <Box
              flexGrow={1}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Editar Item
            </Box>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { md: "600px" },
              height: "100%",
            }}
          >
            {product && shoppingBag ? (
              <>
                <form
                  noValidate
                  onSubmit={formik.handleSubmit}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    padding: 1,
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Box
                      component="img"
                      sx={{
                        borderRadius: "7px",
                        width: {
                          xs: "180px",
                          sm: "200px",
                          md: "280px",
                        },
                        height: {
                          xs: "180px",
                          sm: "200px",
                          md: "280px",
                        },
                      }}
                      src={product?.productInfo.image}
                      alt={product?.productInfo.name}
                    />
                  </Box>
                  <Box marginTop={2}>
                    <Typography
                      fontSize="16px"
                      fontWeight={"700"}
                      color={Colors.grayTextColorDarkestDark}
                    >
                      {product?.productInfo.name}
                    </Typography>


                    { product?.productInfo.show_people_served_information ? (<Typography fontSize="10px" color={Colors.baseTextColor}>
                      Serve até {product?.productInfo.people_served} pessoa(s)
                    </Typography>) : null}


                    <Box
                      sx={{
                        display: "flex",
                      }}
                    >
                      <Typography
                        variant="body2"
                        color="green"
                        style={{
                          fontWeight: 700,
                          fontSize: "20px",
                          marginTop: "12px",
                        }}
                      >
                        {product?.productInfo.new_price.toLocaleString(
                          "pt-br",
                          {
                            style: "currency",
                            currency: "BRL",
                          }
                        )}
                      </Typography>
                      {product?.productInfo.old_price >
                        product?.productInfo.new_price && (
                        <Typography
                          color={Colors.grayTextColorDark}
                          style={{
                            fontWeight: 400,
                            fontSize: "20px",
                            marginTop: "12px",
                            marginLeft: "5px",
                            textDecoration: "line-through",
                          }}
                        >
                          {product?.productInfo.old_price.toLocaleString(
                            "pt-br",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )}
                        </Typography>
                      )}
                    </Box>
                    <Box>
                      {product.compositionGroups.map(
                        (category: ICompositionGroup) => (
                          <Fragment key={category.composition_group_id}>
                            <SeletorDeQuantidadeDeSabores
                              category={category.compositionGroupInfo}
                              onSelecionaQuantidadeDeSabor={selecionaQuantidadeDeSabor}
                              seTelaEditarQuantosSaboresJaSelecionados={
                              qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.compositionGroupInfo?.id ?? -1)}
                            />
                            <Box
                              sx={{
                                backgroundColor: 'lightGray',
                                display: "flex",
                              }}
                            >
                              <Box>
                                <Typography
                                  style={{
                                    fontWeight: 700,
                                    fontSize: "13px",
                                  }}
                                >
                                  {category.compositionGroupInfo?.description}
                                </Typography>
                                <Typography
                                  color={Colors.baseTextColor}
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "12px",
                                  }}
                                >
                                  {
                                    category.compositionGroupInfo?.flavour_control
                                      ? !qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.compositionGroupInfo?.id)
                                        ? `Escolha a quantidade de sabores`
                                        : `${getSelectedItemsCountFor(category.compositionGroupInfo!)} de ${qtdsMaximasDeSaboresPorCategoriaEscolhidasPeloUsuario.get(category.compositionGroupInfo?.id ?? -1)}`
                                      :`${getSelectedItemsCountFor(category.compositionGroupInfo!)} de ${category.compositionGroupInfo?.max}`
                                  }
                                </Typography>
                              </Box>
                              <Box flexGrow={1} />
                              <Box>
                                {
                                  // ************************************************************************************
                                  //    AQUI É O 'RETANGULO' QUE FICA VERDE OU VERMELHO
                                  //    DEPENDENDO SE ESCOLHEU TODOS E A QUANTIDADE DE SABORES OBRIGATÓRIOS
                                  // ************************************************************************************
                                  // se controla sabores, escolheu todos?
                                  (isQuantidadeItensEscolhidosSuficiente(category.compositionGroupInfo!))
                                    // exibe OK:
                                    ? (<Paper
                                      sx={{
                                        paddingX: "4px",
                                        paddingY: "4px",
                                        backgroundColor: category?.compositionGroupInfo?.mandatory
                                          ? "green"
                                          : Colors.grayTextColorDark,
                                        minWidth: "58.77px",
                                        textAlign: "center",
                                      }}
                                      variant="elevation"
                                      elevation={3}
                                    >
                                      <Typography fontSize={"10px"} color="white">
                                        OK
                                      </Typography>
                                    </Paper>)

                                    // Senão, exibe Obrigatório ou Opcional
                                    : (<Paper
                                        sx={{
                                          paddingX: "4px",
                                          paddingY: "4px",
                                          minWidth: "58.77px",
                                          backgroundColor: category?.compositionGroupInfo?.mandatory
                                            ? "red"
                                            : Colors.grayTextColorDark,
                                          textAlign: "center",
                                        }}
                                        variant="elevation"
                                        elevation={3}
                                      >
                                        <Typography fontSize={"10px"} color="white">
                                          {category?.compositionGroupInfo?.mandatory
                                            ? "Obrigatório"
                                            : "Opcional"}
                                        </Typography>
                                      </Paper>
                                    )}
                              </Box>
                            </Box>
                            <FormControl fullWidth>
                              <RadioGroup
                                name={
                                  category.compositionGroupInfo?.description
                                }
                              >
                                {category.compositionGroupItems
                                  .filter(
                                    (itens: ICompositionItemObject) =>
                                      itens.users_orders_items_composition_groups_id ===
                                      category.id
                                  )
                                  .map((item: ICompositionItemObject) => (
                                    /* SUBITENS ********************************************************************/
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                      key={item.id}
                                    >
                                      <Box>
                                        <Typography
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "14px",
                                          }}
                                        >
                                          {item.name}
                                        </Typography>
                                        <Typography
                                          color={Colors.baseTextColor}
                                          style={{
                                            fontWeight: 400,
                                            fontSize: "11px",
                                          }}
                                        >
                                          {item.price.toLocaleString("pt-br", {
                                            style: "currency",
                                            currency: "BRL",
                                          })}
                                        </Typography>
                                      </Box>
                                      <Box flexGrow={1} />
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        {seletorDeItem(item, category.compositionGroupInfo)}
                                      </Box>
                                    </Box>
                                  ))}
                              </RadioGroup>
                            </FormControl>
                          </Fragment>
                        )
                      )}
                    </Box>
                    <Typography
                      variant="body2"
                      color="black"
                      style={{
                        fontWeight: 700,
                        fontSize: "12px",
                        marginTop: "12px",
                      }}
                    >
                      Observações?
                    </Typography>
                    <TextField
                      sx={{ marginTop: "5px" }}
                      fullWidth
                      id="observations"
                      placeholder="Ex: Não colocar salada, ketchup a parte, etc."
                      variant="standard"
                      onChange={formik.handleChange}
                      value={formik.values.observations}
                    />
                  </Box>
                  <Box marginTop="auto">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        marginTop: "5px",
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: "20px",
                          color: "white",
                          minWidth: "30px",
                          maxHeight: "30px",
                          width: "30px",
                        }}
                        onClick={() => {
                          handleQuantity("remove");
                        }}
                        disabled={formik.values.quantity === 1}
                      >
                        -
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: "20px",
                          color: "white",
                          minWidth: "30px",
                          maxHeight: "30px",
                          width: "30px",
                          marginLeft: "5px",
                        }}
                        onClick={() => {
                          handleQuantity("add");
                        }}
                      >
                        +
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        fontSize="11px"
                        style={{ fontWeight: 400 }}
                        color={Colors.grayTextColorDarkestDark}
                      >
                        TOTAL
                      </Typography>
                      <Box sx={{ flexGrow: 1 }} />
                      <Typography
                        fontSize="11px"
                        style={{ fontWeight: 400 }}
                        color={Colors.grayTextColorDarkestDark}
                      >
                        QUANT.
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        fontSize="11px"
                        style={{ fontWeight: 400 }}
                        color={Colors.grayTextColorDarkestDark}
                      >
                        R$
                      </Typography>
                      {/* Precisa mudar aqui o total value */}
                      <Typography
                        fontSize="16px"
                        style={{ fontWeight: 700 }}
                        color={Colors.grayTextColorDarkestDark}
                      >
                        {formik.values.total_value?.toLocaleString("pt-br", {
                          minimumFractionDigits: 2,
                        })}
                      </Typography>
                      <Box sx={{ flexGrow: 1 }} />
                      <Typography
                        fontSize="16px"
                        style={{ fontWeight: 700 }}
                        color={Colors.grayTextColorDarkestDark}
                      >
                        x{formik.values.quantity}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Button
                      sx={{
                        width: "100%",
                        color: "white",
                        textTransform: "none",
                        marginTop: 1,
                      }}
                      type="submit"
                      variant="contained"
                      disabled={handleDisabledButtonComposition() || formik.isSubmitting}
                    >
                      Atualizar Pedido
                    </Button>
                  </Box>
                </form>
              </>
            ) : ( <EditItemBagDialogSkeleton /> )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default EditItemBagDialog;
